export const SUMMARY_PAGE_LAST_DAYS_LENGHT = 30;
